import { Divider, Form, FormInstance, Radio, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { CheckboxGroupButtons } from '@/components/_common';
import DirectSaleMoreOptions from './DirectSaleMoreOptions';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import DirectSaleSwitch from './DirectSaleSwitch';
import { ReportTypeEnum } from '@/core/domain/reports/financial/directSale/DirectSale.types';

interface Props {
  form: FormInstance;
}

export default function DirectSaleForm({ form }: Props) {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;

  const dataByOptions = [
    {
      value: 'SALE_DATE',
      label: intl({ id: 'movementDirectSale.option.sale' }),
    },
    {
      value: 'AUTHORIZATION',
      label: intl({ id: 'movementDirectSale.option.authorization' }),
    },
    {
      value: 'CANCELLATION',
      label: intl({ id: 'movementDirectSale.option.cancellation' }),
    },
    {
      value: 'CREATE_DATE',
      label: intl({ id: 'movementDirectSale.option.createDate' }),
    },
  ];

  const situationOptions = [
    { value: 'OPEN', label: intl({ id: 'movementDirectSale.option.open' }) },
    {
      value: 'AUTHORIZED',
      label: intl({ id: 'movementDirectSale.option.authorized' }),
    },
    {
      value: 'CANCELED',
      label: intl({ id: 'movementDirectSale.option.canceled' }),
    },
  ];

  const reportTypeOptions = [
    {
      value: ReportTypeEnum.SalesSummary,
      label: intl({ id: 'movementDirectSale.option.salesSummary' }),
    },
    {
      value: ReportTypeEnum.SalesTotal,
      label: intl({ id: 'movementDirectSale.option.totalBySales' }),
    },
    {
      value: ReportTypeEnum.SalesSeller,
      label: intl({ id: 'movementDirectSale.option.seller' }),
    },
  ];

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields
        form={form}
        dateFilter={
          <Form.Item
            name="dateType"
            style={{ margin: '4px 0' }}
            label={
              <Title level={5} style={{ margin: '0' }}>
                {intl({ id: 'movementDirectSale.label.filteByDate' })}
              </Title>
            }
            initialValue="AUTHORIZATION"
          >
            <Radio.Group
              buttonStyle="solid"
              optionType="button"
              options={dataByOptions}
              size="large"
            />
          </Form.Item>
        }
      />

      <Form.Item
        name="lsSituacao"
        style={{ margin: '4px 0' }}
        label={
          <Title level={5} style={{ margin: '0' }}>
            {intl({ id: 'movementDirectSale.label.situation' })}
          </Title>
        }
        initialValue={['AUTHORIZED']}
      >
        <CheckboxGroupButtons options={situationOptions} />
      </Form.Item>

      <Form.Item
        name="reportType"
        style={{ margin: '4px 0' }}
        label={
          <Title level={5} style={{ margin: '0' }}>
            {intl({ id: 'movementDirectSale.label.reportType' })}
          </Title>
        }
        initialValue={ReportTypeEnum.SalesTotal}
      >
        <Radio.Group
          buttonStyle="solid"
          optionType="button"
          options={reportTypeOptions}
          size="large"
        />
      </Form.Item>

      <DirectSaleSwitch />

      <Divider />

      <DirectSaleMoreOptions form={form} />
    </Form>
  );
}
